/* import __COLOCATED_TEMPLATE__ from './paid.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './paid-or-expired.module.scss';

export default class PaymentLinkPaid extends Component {
  styles = styles;

  @service currentPractice;

  get isPaymentLinkSmsEnabled() {
    return this.currentPractice.get('featurePaymentLinksSms');
  }
}
